import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { emailApi } from '../api/emailApi';

export function useEmailAccounts() {
  return useQuery({
    queryKey: keys.email.accounts,
    queryFn: ({ signal }) => emailApi.getAccounts({ signal }),
    staleTime: 300_000,
  });
}

export function useDisconnectEmailAccount() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (accountId: string) => emailApi.disconnectAccount(accountId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: keys.email.accounts });
      void queryClient.invalidateQueries({ queryKey: keys.settings.emailInteg });
    },
  });
}
